import { useCallback } from "react";

const useNovaConversationTracker = () => {
  const getTracker = () => ({
    currentEmployeeId: localStorage.getItem("current_employee_id"),
    novaConversationData: localStorage.getItem("nova_conversation_data"),
  });

  const setCurrentAccount = useCallback((nextEmployeeId) => {
    localStorage.setItem("current_employee_id", nextEmployeeId);
  }, []);

  return { getTracker, setCurrentAccount };
};

export default useNovaConversationTracker;
